import React from 'react';
import { Touchable, type TouchableProps } from './Touchable';

export type IconNavButtonProps = Omit<TouchableProps, 'haptic'>;

const BASE =
  'p-2 rounded-full text-ink-faint active:bg-soft active:scale-95 transition-all touch-manipulation';

export const IconNavButton: React.FC<IconNavButtonProps> = ({ className, ...rest }) => (
  <Touchable haptic="softTap" className={className ? `${BASE} ${className}` : BASE} {...rest} />
);
